module.exports = __webpack_public_path__ + "/login_ui/img/fk-79c6cee2df65995ac78091d2964b2fe8.svg";